// extracted by mini-css-extract-plugin
module.exports = {"pane":"ProductsTab_pane__pijqW","header":"ProductsTab_header__3Kcyv","search":"ProductsTab_search__1LKPF","actions":"ProductsTab_actions__2Emxn","list":"ProductsTab_list__stECS"};